/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ChangePasswordInput = {
    id: string;
    currentPassword: string;
    newPassword: string;
};
export type ChangePasswordUserMutationVariables = {
    input: ChangePasswordInput;
};
export type ChangePasswordUserMutationResponse = {
    readonly changePassword: {
        readonly user: {
            readonly id: string;
        };
    };
};
export type ChangePasswordUserMutation = {
    readonly response: ChangePasswordUserMutationResponse;
    readonly variables: ChangePasswordUserMutationVariables;
};



/*
mutation ChangePasswordUserMutation(
  $input: ChangePasswordInput!
) {
  changePassword(input: $input) {
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangePasswordPayload",
    "kind": "LinkedField",
    "name": "changePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7fa4ea2ac3ba1ea4eb93cc24834f924b",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordUserMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordUserMutation(\n  $input: ChangePasswordInput!\n) {\n  changePassword(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '43b2132c4e115e62fe19ad8df867d0ec';
export default node;
